import { render } from "./PhotoItem.vue?vue&type=template&id=32540918&scoped=true"
import script from "./PhotoItem.vue?vue&type=script&lang=js"
export * from "./PhotoItem.vue?vue&type=script&lang=js"

import "./PhotoItem.vue?vue&type=style&index=0&id=32540918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32540918"]])

export default __exports__